import "./FormCalculator.css";
import { WallGreenForm } from "../wallgreen-form";
import { GrowGreenForm } from "../growgreen-form";
import { SystemImg } from "../system-img";

export const FormCalculator = ({
  formType,
  setCalculatorDataResult,
  language,
}) => {
  const selectedForm = formType;

  return (
    <div className="form-container">
      {selectedForm === "wallgreen" && (
        <WallGreenForm
          setCalculatorDataResult={setCalculatorDataResult}
          language={language}
        />
      )}
      {selectedForm === "growgreen" && (
        <GrowGreenForm
          setCalculatorDataResult={setCalculatorDataResult}
          language={language}
        />
      )}

      <SystemImg type={selectedForm} />
    </div>
  );
};
